import { createSelector } from 'reselect'

import { getProfile } from '@/common/selectors'
import { AGENCY_ID } from '@/const'

export default createSelector([getProfile], (profile) => ({
  cashback: profile.cashback,
  isAgency: profile.industry === AGENCY_ID,
}))
